// formatByteSize — pure: bytes → the human label the DataPanel displays.
//
// Decimal (SI) units, matching what Finder/Explorer show for file sizes, and
// locale-aware digits via Intl (sv renders "3,4 MB", en "3.4 MB"). Whole
// bytes show no decimals; larger units show one. Negative or fractional
// input is clamped/floored — a file size is a non-negative integer, and this
// boundary formatter degrades rather than lies.
//
// Lives beside the Settings panels because the harness (the bridge consumer)
// is the one that formats — the DataPanel itself receives the finished label
// (pre-formatted presentation data, pure view).

const UNITS = ["B", "kB", "MB", "GB", "TB"] as const;

export const formatByteSize = (bytes: number, locale: string): string => {
    const clamped = Math.max(0, Math.floor(bytes));
    const unit =
        clamped < 1000
            ? 0
            : Math.min(UNITS.length - 1, Math.floor(Math.log10(clamped) / 3));
    const value = clamped / 1000 ** unit;
    const label = new Intl.NumberFormat(locale, {
        maximumFractionDigits: unit === 0 ? 0 : 1,
    }).format(value);
    return `${label} ${UNITS[unit]}`;
};
